module.exports = __webpack_public_path__ + "static/media/5-star.d531664a.png";